module.exports = __webpack_public_path__ + "images/sgp/featuredContentImages/mediumSizeRelatedContentImage4.webp";